import React from 'react';

export function OptionModal({ open, onClose, options, onSelect, selected, price }: {
  open: boolean;
  onClose: () => void;
  options: { colors: string[]; sizes: string[] };
  onSelect: (type: 'color' | 'size', value: string) => void;
  selected: { color: string; size: string };
  price: number;
}) {
  const isAllSelected = selected.color && selected.size;
  return (
    <div style={{
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: open ? 0 : '-100%',
      transition: 'bottom 0.3s',
      background: '#fff',
      borderTopLeftRadius: 24, borderTopRightRadius: 24,
      zIndex: 200,
      boxShadow: '0 -2px 16px rgba(0,0,0,0.1)',
      padding: 24,
      minHeight: 400,
      width: '100%',
      maxWidth: '100%',
      margin: 0,
      display: 'flex', flexDirection: 'column',
    }}>
      <button onClick={onClose} style={{ position: 'absolute', right: 24, top: 24, background: 'none', border: 'none', fontSize: 28, cursor: 'pointer' }}>×</button>
      <h2 style={{ fontWeight: 700, fontSize: 22, marginBottom: 24 }}>옵션 선택</h2>
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 8 }}>색상</div>
        <select
          value={selected.color}
          onChange={e => onSelect('color', e.target.value)}
          style={{ width: '100%', padding: 12, fontSize: 16, borderRadius: 8, border: '1px solid #eee', color: selected.color ? '#222' : '#aaa', marginBottom: 16 }}
        >
          <option value="">색상을 선택하세요</option>
          {options.colors.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
        <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 8 }}>사이즈</div>
        <select
          value={selected.size}
          onChange={e => onSelect('size', e.target.value)}
          style={{ width: '100%', padding: 12, fontSize: 16, borderRadius: 8, border: '1px solid #eee', color: selected.size ? '#222' : '#aaa' }}
        >
          <option value="">사이즈를 선택하세요</option>
          {options.sizes.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      <div style={{ background: '#fafafa', borderRadius: 12, padding: 20, marginBottom: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 16, marginBottom: 8 }}>
          <span>총 상품금액</span>
          <span>{isAllSelected ? price.toLocaleString() + '원' : '0원'}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 16, marginBottom: 8 }}>
          <span>배송비</span>
          <span>무료</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700, fontSize: 18 }}>
          <span>총 결제금액</span>
          <span>{isAllSelected ? price.toLocaleString() + '원' : '0원'}</span>
        </div>
      </div>
      <button
        style={{
          width: '100%', background: '#222', color: '#fff', border: 'none', borderRadius: 16,
          fontSize: 24, fontWeight: 400, padding: '18px 0', marginTop: 8, opacity: isAllSelected ? 1 : 0.5, cursor: isAllSelected ? 'pointer' : 'not-allowed'
        }}
        disabled={!isAllSelected}
      >
        주문하기
      </button>
    </div>
  );
} 